<template>
  <section class="config-group suggests" aria-label="Search Suggestions">
      <div class="column">
        <div class="row stretch" style="max-width: 400px; margin-bottom:1.5em">
            <Checkmark :label="texts.suggestions.show" checkbox-id="show-suggests--i" v-model="config.suggestions.show"/>
        </div>
        <div class="row" v-if="config.suggestions.show">
            <div class="column">
                <h3>{{texts.global.basicSettings}}</h3>
                <div class="row stretch"  style="margin: 0.5em 0;">
                    <label for="ss-minchars--i">{{texts.suggestions.minChars}}</label>
                    <input id="ss-minchars--i" min="1" max="10" type="number" v-model="config.suggestions.minChars"/>
                </div>
                <div class="row stretch"  style="margin: 0.5em 0;">
                    <label for="ss-num--i">{{texts.suggestions.num}}</label>
                    <input id="ss-num--i" min="1" max="20" type="number" v-model="config.suggestions.num"/>
                </div>
                <Checkmark style="margin: 0.5em 0;" :label="texts.global.showImages" checkbox-id="show-images-s--i" v-model="config.suggestions.showImages"/>
                <Checkmark style="margin: 0.5em 0;" :label="texts.global.highlightQueryTerms" checkbox-id="highlight-s--i" v-model="config.suggestions.highlight"/>
                <Checkmark style="margin: 0.5em 0;" :label="texts.suggestions.appendSearchButton" checkbox-id="viewall-s--i" @input="onViewAllToggle" :value="config.suggestions.viewAllLabel!==undefined"/>
                <div v-if="config.suggestions.viewAllLabel!==undefined" class="align-right">
                    <input type="text" v-model="config.suggestions.viewAllLabel" style="width: 150px;"/>
                </div>
                <Checkmark :label="texts.suggestions.suggestionsLayover" checkboxId="suggest-mobile--i" v-model="config.specialMobileSuggest.enabled"  style="margin: 0.5em 0;"/>
                <Checkmark :label="texts.suggestions.scrollToSearchBox" checkboxId="suggest-scroll--i" v-if="!config.specialMobileSuggest.enabled" v-model="config.suggestions.mobileScrollOnFocus"  style="margin: 0.5em 0;"/>
            </div>
            <div class="column">
                <h3>{{texts.global.style}}</h3>
                <ExpandableColorPicker type="inline" :title="texts.global.backgroundColor" :value="config.style.suggestions.background.color" :onChange="updateBackgroundColor" />
                <div class="row stretch"  style="margin: 0.5em 0;">
                    <label for="ss-padding--i">{{texts.global.padding}}</label>
                    <input id="ss-padding--i" type="number" min="0" max="20" :value="padding" @change="onPaddingChange"/>
                </div>
                <div class="row stretch"  style="margin: 0.5em 0;">
                    <label for="ss-distance--i">{{texts.suggestions.distanceToSearchBox}}</label>
                    <input id="ss-distance--i" type="number" min="0" max="50" :value="distance" @change="onDistanceChange"/>
                </div>
                <div class="row stretch"  style="margin: 0.5em 0;">
                    <label for="ss-border-radius--i">{{texts.global.borderRadius}}</label>
                    <input id="ss-border-radius--i" type="number" min="0" max="20" :value="borderRadius" @change="onBorderRadiusChange"/>
                </div>
                <ExpandableColorPicker type="inline" :title="texts.global.borderColor" :value="config.style.suggestions.border.color" :onChange="updateBorderColor" />      
                <ExpandableColorPicker type="inline" :title="texts.global.textColor" :value="config.style.suggestions.text.color" :onChange="updateTextColor" />
            </div>
        </div>
      </div>
  </section>
</template>

<script>
import Vue from 'vue';
import Checkmark from '../Checkmark';
import ExpandableColorPicker from "../ExpandableColorPicker"

export default {
  name: "SearchSuggestions",
  components:{
      ExpandableColorPicker,
      Checkmark
  },
  props: {
      config: {
          type: Object,
          required: true
      }
  },
  computed: {
      padding(){return this.config.style.suggestions.padding.replace('px','')},
      distance(){return this.config.style.suggestions.distanceFromTop.replace('px','')},
      borderRadius(){return this.config.style.suggestions.border.radius.replace('px','')}
  },
  methods: {
      updateTextColor(color){Vue.set(this.config.style.suggestions.text, 'color',color.hex);},
      updateBackgroundColor(color){Vue.set(this.config.style.suggestions.background, 'color',color.hex);},
      updateBorderColor(color){Vue.set(this.config.style.suggestions.border, 'color',color.hex);},
      onPaddingChange(e){Vue.set(this.config.style.suggestions, 'padding', e.target.value+'px')},
      onDistanceChange(e){Vue.set(this.config.style.suggestions, 'distanceFromTop', e.target.value+'px')},
      onBorderRadiusChange(e){Vue.set(this.config.style.suggestions.border, 'radius', e.target.value+'px')},
      onViewAllToggle(e){Vue.set(this.config.suggestions, 'viewAllLabel', e?this.texts.suggestions.showAll: undefined)}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configuration/SearchSuggestions.vue